// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Column-module__main--U9Vlw {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.Column-module__noGap--bT9Uj {
    gap: 0;
}
`, "",{"version":3,"sources":["webpack://./src/dom/components/Panel/Column.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,MAAM;AACV","sourcesContent":[".main {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.noGap {\n    gap: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `Column-module__main--U9Vlw`,
	"noGap": `Column-module__noGap--bT9Uj`
};
export default ___CSS_LOADER_EXPORT___;
